<script setup lang="ts">
import { useDisciplineGeneralBalance } from '../model/discipline-general-balance.hook'
import DisciplineBalanceCard from './DisciplineBalanceCard.vue'
import DisciplineBalanceItem from './DisciplineBalanceItem.vue'
import DisciplineWeeklySchedule from './DisciplineWeeklySchedule.vue'

defineOptions({
  name: 'DisciplineGeneralBalance',
})

const {
  refPace,
  refUnscheduled,
  refBookingsInfo,
  refSkipped,
  refSkippedTooltip,
  refIsWeeklyScheduleVisible,
  tooltips,
} = useDisciplineGeneralBalance()
</script>

<template>
  <div class="discipline-general-balance">
    <DisciplineBalanceCard title="Lesson balance">
      <DisciplineBalanceItem
        label="Pace"
        :value="refPace"
        :tooltip-text="tooltips.pace"
      />
      <DisciplineBalanceItem
        label="Unscheduled"
        :value="refUnscheduled"
        :tooltip-text="tooltips.unscheduled"
      />
    </DisciplineBalanceCard>
    <DisciplineBalanceCard title="Lesson statuses">
      <DisciplineBalanceItem
        label="Confirmed"
        :value="refBookingsInfo.confirmed"
        :tooltip-text="tooltips.confirmed"
      />
      <DisciplineBalanceItem
        label="Reserved"
        :value="refBookingsInfo.reserved"
        :tooltip-text="tooltips.reserved"
      />
      <DisciplineBalanceItem
        label="Completed"
        :value="refBookingsInfo.completed"
        :tooltip-text="tooltips.completed"
      />
      <DisciplineBalanceItem
        label="Skipped"
        :value="refSkipped"
        :tooltip-text="refSkippedTooltip"
      />
    </DisciplineBalanceCard>
    <DisciplineWeeklySchedule v-if="refIsWeeklyScheduleVisible" />
  </div>
</template>

<style scoped lang="scss" src="./DisciplineGeneralBalance.scss" />
